module.exports = __webpack_public_path__ + "static/img/CDClogo.8bc065c2.png";